import apiClient from "./apiClient";
import { LoginDto, LoginResponseDto } from "../types/login";

class AuthService {
  // 1. Σύνδεση
  async login(credentials: LoginDto): Promise<LoginResponseDto> {
    const response = await apiClient.post<LoginResponseDto>(
      "/Auth/login",
      credentials,
    );
    const data = response.data || response;

    if (data && data.token) {
      localStorage.setItem("user", JSON.stringify(data));
    }

    return data as LoginResponseDto;
  }

  logout(): void {
    localStorage.removeItem("user");
    window.location.href = "/login";
  }

  // 3. Ανάγνωση τρέχοντος χρήστη
  getCurrentUser(): LoginResponseDto | null {
    const userStr = localStorage.getItem("user");
    if (!userStr) return null;

    try {
      return JSON.parse(userStr) as LoginResponseDto;
    } catch (error) {
      console.error("Failed to parse user from localStorage", error);
      this.logout();
      return null;
    }
  }

  // 4. Επιστροφή token
  getToken(): string | null {
    const userData = this.getCurrentUser();
    return userData ? userData.token : null;
  }

  // 5. Ανάκτηση / Αποστολή στοιχείων αυθεντικοποίησης
  async recoverCredentials(data: { email: string }): Promise<any> {
    const response = await apiClient.post("/Auth/recover-credentials", data);
    return response.data || response;
  }
}

const authService = new AuthService();
export default authService;